import { SPECIALTY_IDS } from '@zocdoc-frontend-common/utils-constants';

export const ACTION_TYPES = {
    PAGE_LOAD: '@@PAGE_LOAD',
};
export const BusinessUnit = {
    PATIENT_WEB_APP: 'PatientWebApp',
    GA_EVENT: 'GA-Event', // for legacy
};

export const EVENT_TYPES = {
    Pageview: 'Pageview',
    Action: 'Action',
    SetCustomDimension: 'Set custom dimension',
    SetContentGroup: 'Set content group',
    FullStoryUrl: 'FullStoryUrl',
    DidHideSyncOverlay: 'DidHideSyncOverlay',
    DidShowSyncOverlay: 'DidShowSyncOverlay',
};

export const EventDataSchemaVersion = {
    [BusinessUnit.PATIENT_WEB_APP]: {
        [EVENT_TYPES.Pageview]: '2.1.0',
        [EVENT_TYPES.Action]: '2.1.0',
        [EVENT_TYPES.SetCustomDimension]: '2.1.0',
        [EVENT_TYPES.SetContentGroup]: '2.1.0',
        [EVENT_TYPES.FullStoryUrl]: '2.0.0',
        [EVENT_TYPES.DidHideSyncOverlay]: '2.0.0',
        [EVENT_TYPES.DidShowSyncOverlay]: '2.0.0',
    },
};

export const ProcedureIds = {
    ANNUAL_PHYSICAL: '76',
    DENTAL_CLEANING: '11',
    ILLNESS: '75',
    ORTHOPEDIC_CONSULTATION: '104',
    PLASTIC_SURGERY_CONSULTATION: '349',
    SKIN_SCREENING: '85',
    VISION_EXAM: '92',
};

export const SpecialtyIds = {
    ACUPUNCTURE_ORIENTAL_MEDICINE: '365',
    ADULT_PSYCHIATRIC_AND_MENTAL_HEALTH_NURSE_PRACTITIONER: '405',
    ALLERGIST: '132',
    CHILD_ADOLESCENT_PSYCHIATRIST: '250',
    CHILD_ADOLESCENT_PSYCHIATRIST_PEDIATRIC: '251',
    CHILD_ADOLESCENT_PSYCHOLOGIST: '416',
    DENTIST: '98',
    DERMATOLOGIST: '101',
    DIETITIAN: '359',
    EMERGENCY_MEDICINE_PHYSICIAN: '146',
    ENT: '130',
    EYE_DOCTOR: '386',
    FACIAL_PLASTIC_SURGEON: '167',
    FAMILY_PHYSICIAN: '102',
    FAMILY_PSYCHIATRIC_AND_MENTAL_HEALTH_NURSE_PRACTITIONER: '406',
    FORENSIC_PSYCHIATRIST: '280',
    GASTROENTEROLOGIST: '106',
    GENETICIST: '148',
    GERIATRIC_PSYCHIATRIST: '281',
    IMMUNOLOGIST: '154',
    INTERNIST: '99',
    MARRIAGE_FAMILY_THERAPIST: '438',
    MEDICAL_ETHICIST: '354',
    MENTAL_HEALTH_NURSE_PRACTITIONER: '407',
    MICROBIOLOGIST: '159',
    NATUROPATHIC: '373',
    NEUROPSYCHIATRIST: '383',
    OBGYN: '104',
    OPTOMETRIST: '157',
    ORTHOPEDIC_SURGEON: '117',
    PEDIATRIC_DENTIST: '152',
    PEDIATRICIAN: '100',
    PHYSICAL_THERAPIST: '335',
    PHYSICIAN_ASSISTANT: '381',
    PLASTIC_SURGEON: '120',
    PRIMARY_CARE_PHYSICIAN: '153',
    PSYCHIATRIST: '122',
    PSYCHIATRIST_PSYCHOLOGIST: '350',
    PSYCHOSOMATIC_MEDICINE_SPECIALIST: '299',
    PSYCHOTHERAPIST: '352',
    PSYCHOLOGIST: '337',
    ENDODONTIST: '134',
    ORTHODONTIST: '135',
    PERIODONTIST: '136',
    PROSTHODONTIST: '137',
    ORAL_SURGEON: '151',
    THERAPIST_COUNSELOR: '387',
    COVID_VACCINE_FACILITY: '510',
};

export const PCP_SPECIALTIES = [
    SPECIALTY_IDS.PRIMARY_CARE_PHYSICIAN,
    SPECIALTY_IDS.NURSE_PRACTITIONER,
    SPECIALTY_IDS.FAMILY_PHYSICIAN,
    SPECIALTY_IDS.INTERNIST,
    SPECIALTY_IDS.MED_PED_PHYSICIAN,
    SPECIALTY_IDS.NATUROPATHIC_DOCTOR,
    SPECIALTY_IDS.INTERNIST_RESIDENT,
    SPECIALTY_IDS.INFECTIOUS_DISEASE_SPECIALIST,
    SPECIALTY_IDS.EMERGENCY_MEDICINE_PHYSICIAN,
    SPECIALTY_IDS.CORONAVIRUS_TESTING_FACILITY,
    SPECIALTY_IDS.ADULT_NURSE_PRACTITIONER,
    SPECIALTY_IDS.FAMILY_NURSE_PRACTITIONER,
    SPECIALTY_IDS.PHYSICIAN_ASSISTANT,
    SPECIALTY_IDS.REGISTERED_NURSE,
    SPECIALTY_IDS.ACUTE_CARE_NURSE_PRACTITIONER,
    SPECIALTY_IDS.COVID_VACCINE_FACILITY,
    SPECIALTY_IDS.FAMILY_PHYSICIAN_RESIDENT,
    SPECIALTY_IDS.PREVENTIVE_MEDICINE_SPECIALIST,
    SPECIALTY_IDS.TRAVEL_MEDICINE_SPECIALIST,
    SPECIALTY_IDS.COVID_TESTING_FACILITY,
    SPECIALTY_IDS.GERONTOLOGY_NURSE_PRACTITIONER,
    SPECIALTY_IDS.BARIATRIC_PHYSICIAN,
    SPECIALTY_IDS.URGENT_CARE_SPECIALIST,
    SPECIALTY_IDS.GERIATRICIAN,
];

export const OBGYN_SPECIALTIES = [
    SPECIALTY_IDS.UROGYNECOLOGIST,
    SPECIALTY_IDS.WOMENS_HEALTH_NURSE_PRACTITIONER,
    SPECIALTY_IDS.MIDWIFE,
    SPECIALTY_IDS.OB_GYN_NURSE_PRACTITIONER,
    SPECIALTY_IDS.MATERNAL_FETAL_MEDICINE_SPECIALIST,
    SPECIALTY_IDS.OBSTETRICIAN,
    SPECIALTY_IDS.OB_GYN_RESIDENT,
    SPECIALTY_IDS.GYNECOLOGIST,
    SPECIALTY_IDS.OB_GYN,
];

export const DERMATOLOGIST_SPECIALTIES = [
    SPECIALTY_IDS.DERMATOLOGY_NURSE_PRACTITIONER,
    SPECIALTY_IDS.DERMATOLOGIST,
];

export const MENTAL_HEALTH_SPECIALTIES = new Set([
    SpecialtyIds.ADULT_PSYCHIATRIC_AND_MENTAL_HEALTH_NURSE_PRACTITIONER,
    SpecialtyIds.CHILD_ADOLESCENT_PSYCHIATRIST,
    SpecialtyIds.CHILD_ADOLESCENT_PSYCHIATRIST_PEDIATRIC,
    SpecialtyIds.CHILD_ADOLESCENT_PSYCHOLOGIST,
    SpecialtyIds.FAMILY_PSYCHIATRIC_AND_MENTAL_HEALTH_NURSE_PRACTITIONER,
    SpecialtyIds.FORENSIC_PSYCHIATRIST,
    SpecialtyIds.GERIATRIC_PSYCHIATRIST,
    SpecialtyIds.MARRIAGE_FAMILY_THERAPIST,
    SpecialtyIds.MENTAL_HEALTH_NURSE_PRACTITIONER,
    SpecialtyIds.NEUROPSYCHIATRIST,
    SpecialtyIds.PSYCHIATRIST,
    SpecialtyIds.PSYCHIATRIST_PSYCHOLOGIST,
    SpecialtyIds.PSYCHOLOGIST,
    SpecialtyIds.PSYCHOSOMATIC_MEDICINE_SPECIALIST,
    SpecialtyIds.PSYCHOTHERAPIST,
    SpecialtyIds.THERAPIST_COUNSELOR,
]);

export const VIRTUAL_VISIT_TYPES = {
    NONE: 'None',
    ZOCDOC_VIDEO_VISIT: 'ZocdocVideoVisit',
    THIRD_PARTY_VIDEO_VISIT: 'ThirdPartyVideoVisit',
};

export const ZOCDOC_URLS = {
    LOG_IN: '/signin',
    LOG_OUT: '/signout',
    PATIENT_HOME: '/patient/medicalteam',
};
